/**
 * Handles last blocks and block info per blockchain
 */
import { ACTION_BSC_BLOCK, ACTION_ETH_BLOCK, ACTION_POLYGON_BLOCK, ACTION_GAS_PRICE } from '../actions/blockchains';
import { IGasState } from '../core/BlocksSubscription';

export interface IGasHashMap {
  BSC: IGasState,
  ETH: IGasState,
  POLYGON: IGasState,
}
export interface IBlockChainsState {
  ETH: number;
  BNB: number;
  POLYGON: number;
  GAS: IGasHashMap,
}

const emptyGasStructure: IGasState = {
  FastGasPrice: '',
  LastBlock: '',
  ProposeGasPrice: '',
  SafeGasPrice: ''
};

const defaultState = {
  ETH: 0,
  BNB: 0,
  POLYGON: 0,
  GAS: {
    BSC: emptyGasStructure,
    ETH: emptyGasStructure,
    POLYGON: emptyGasStructure,
  }
};

const blockchainsReducer = (state: IBlockChainsState = defaultState, action: any) => {
  switch (action.type) {
  case ACTION_ETH_BLOCK:
    return {
      ...state,
      ETH: action.payload
    };
  case ACTION_BSC_BLOCK:
    return {
      ...state,
      BNB: action.payload
    };
  case ACTION_POLYGON_BLOCK:
    return {
      ...state,
      POLYGON: action.payload
    };
  case ACTION_GAS_PRICE:
    return {
      ...state,
      GAS: {
        ...state.GAS,
        [action.payload.Network]: action.payload
      }
    };
  default:
    return state;
  }
};

export default blockchainsReducer;